import rcPlacements from 'choerodon-ui/lib/rc-components/tooltip/placements';
import getPlacements, { AdjustOverflow, getOverflowOptions, PlacementsConfig } from 'choerodon-ui/lib/tooltip/placements';
export { rcPlacements, AdjustOverflow, PlacementsConfig, getOverflowOptions, getPlacements as default, };
